/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NetCloudCheckIcon24Solid = forwardRef('NetCloudCheckIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.081 6.806a6.6 6.6 0 0 0-12.46 1.528A6 6 0 0 0 6.6 20h10.2a6.6 6.6 0 0 0 .281-13.194Zm-.553 4.74a1.125 1.125 0 0 0-1.591-1.591l-4.545 4.544-1.916-1.915a1.125 1.125 0 0 0-1.59 1.59L8.89 16.18c.83.83 2.175.83 3.005 0l4.633-4.633Z" })));
});
